import { TrainingPhase } from 'common/types'

export type LobbyMoment = 'not_started' | 'break'

/**
 * A stationary scheme is created in its break phase, so the lobby is where a
 * participant waits both before the start and during a break - and the
 * interaction-scheme phase reads `TRAINING_BREAK` in both cases. What tells
 * them apart is whether the training was ever anywhere else: before the
 * start there is no previous phase.
 */
export const lobbyMomentOf = (phase: TrainingPhase): LobbyMoment =>
	phase.previousPhase ? 'break' : 'not_started'

/**
 * The planned time, only while it is still ahead. The script's times are a
 * plan: a break the trainer starts by hand, or a start that runs late, leaves
 * the next item's planned time behind - and "we are back at 12:23" read at
 * 14:38 is worse than no time at all.
 */
export const stillAhead = (
	at: Date | undefined,
	now: number
): Date | undefined => (at && at.getTime() > now ? at : undefined)
